import React from 'react'
import abpseeds from "../images/paddy seeds pratiksha.jpg";

function About() {
  return (
    <div>
      <div className="album py-1">
        <div className="container">
          <div className="row ">
            <div className="col-md-12 mt-2">
              <h1 className='mb-2 justify'>About <b style={{ color: "#3D2219" }}> ABP Seeds Corporation</b></h1>

              <p>ABP Seeds Corporation is a trusted name in the agricultural seeds industry, committed to delivering high-quality, high-yield seed varieties to farmers across India. With a strong focus on innovation, sustainability, and farmer success, we specialize in premium mustard seeds that ensure better productivity and superior crop performance.</p>
              <p>Why Choose ABP Seeds Corporation?
                Premium quality, certified seeds
                High germination and yield performance
                Focus on research-based seed development
                Suitable for diverse Indian climatic conditions
                Trusted by farmers for consistent results</p>
                <p>We combine traditional agricultural knowledge with modern seed processing techniques to provide products that meet the evolving needs of farmers, traders, and consumers.</p>
            </div>
            {/* <div className="col-md-6 mt-2">
                <img src={abpseeds} className="card-img-top" alt="abpseeds" />

                </div> */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default About